import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import AdminScraping from '@/pages/AdminScraping';
import AdminUsers from '@/pages/AdminUsers';
import AdminReports from '@/pages/AdminReports';

const ADMIN_CODE = 'webeos123';

export default function AdminPanel() {
  const [code, setCode] = useState('');
  const [authenticated, setAuthenticated] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleCodeSubmit = (e) => {
    e.preventDefault();
    if (code === ADMIN_CODE) {
      setAuthenticated(true);
      setError(null);
    } else {
      setError('Code incorrect');
    }
  };

  if (!authenticated) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center px-4">
        <Card className="bg-bg-secondary border-white/10 w-full max-w-md">
          <CardHeader>
            <div className="text-center mb-4">
              <Lock className="w-16 h-16 text-netflix-red mx-auto mb-4" />
              <CardTitle className="text-3xl font-bebas text-white">Admin Panel</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleCodeSubmit} className="space-y-4">
              <Input
                type="password"
                placeholder="Code admin"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
                className="bg-bg-tertiary border-white/20 text-white text-center text-2xl font-mono"
                data-testid="admin-password-input"
              />
              {error && (
                <div className="p-3 bg-red-900/20 border border-red-500/50 rounded-md">
                  <p className="text-red-200 text-sm text-center">{error}</p>
                </div>
              )}
              <Button type="submit" className="w-full bg-netflix-red hover:bg-netflix-red-hover py-6" data-testid="admin-login-btn">
                Valider
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-bg-primary">
      <div className="bg-black/90 backdrop-blur-xl border-b border-white/10 sticky top-0 z-50">
        <div className="px-4 md:px-8 py-4 flex items-center justify-between">
          <h1 className="font-bebas text-3xl text-netflix-red">WEBEOS ADMIN</h1>
          <Button onClick={() => navigate('/')} className="bg-netflix-red hover:bg-netflix-red-hover">
            Retour au Site
          </Button>
        </div>
      </div>

      <div className="px-4 md:px-8 py-8">
        <Tabs defaultValue="scraping" className="w-full">
          <TabsList className="bg-bg-secondary border border-white/10 mb-6 w-full justify-start">
            <TabsTrigger value="scraping" className="data-[state=active]:bg-netflix-red px-8 py-3">
              Scraping
            </TabsTrigger>
            <TabsTrigger value="users" className="data-[state=active]:bg-netflix-red px-8 py-3">
              Utilisateurs
            </TabsTrigger>
            <TabsTrigger value="reports" className="data-[state=active]:bg-netflix-red px-8 py-3">
              Signalements
            </TabsTrigger>
          </TabsList>
          <TabsContent value="scraping"><AdminScraping /></TabsContent>
          <TabsContent value="users"><AdminUsers /></TabsContent>
          <TabsContent value="reports"><AdminReports embedded={true} /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
